import { useEditAgencyEmployeePermissions } from "@entities/agency/lib/hooks/useEditAgencyEmployeePermissions";
import { useGetAgencyPermissions } from "@entities/agency/lib/hooks/useGetAgencyPermissions";
import { ToastService } from "@shared/lib/services";
import { AgencyUser } from "@shared/lib/types/agency";
import { Button } from "@shared/ui/Button";
import { Checkbox } from "@shared/ui/Checkbox";
import { Divider } from "antd";
import hash from "object-hash";
import { useEffect, useMemo, useState } from "react";
import styles from "../styles.module.scss";

interface PermissionProps {
  agencyUser: AgencyUser;
  agencyId: string;
  onSuccess: () => void;
}

export function Permissions({
  agencyUser,
  agencyId,
  onSuccess,
}: PermissionProps) {
  const { agencyPermissions, isFetching } = useGetAgencyPermissions();

  const { editAgencyUserPermissions, isEditing, isEdited, isEditFailed } =
    useEditAgencyEmployeePermissions();

  useEffect(() => {
    if (isEditFailed) {
      ToastService.error("Permissions couldn't be edited.");
    }
  }, [isEditFailed]);

  const [selectedKeys, setSelectedKeys] = useState<string[]>(
    agencyUser?.permissions || []
  );
  const permissions: string[] = useMemo(() => {
    return [...selectedKeys];
  }, [isEdited]);
  const generateHash = (arr: string[]) => hash(arr.sort());

  useEffect(() => {
    if (isEdited) {
      ToastService.success("Permissions updated");
      onSuccess();
    }
  }, [isEdited]);

  return (
    <div className={styles.card}>
      <div className={styles.permTitle} style={{ padding: "8px 12px" }}>
        Permissions
      </div>
      <Divider style={{ margin: 0 }} />
      <div className={styles.permContent}>
        <Checkbox.Group
          options={agencyPermissions}
          value={selectedKeys}
          style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          onChange={(values) => setSelectedKeys(values)}
        />
      </div>
      <div className={styles.footer}>
        <Button onClick={() => setSelectedKeys(permissions)}>Cancel</Button>
        <Button
          type="primary"
          disabled={generateHash(selectedKeys) === generateHash(permissions)}
          loading={isEditing}
          onClick={() =>
            editAgencyUserPermissions({
              agencyId: agencyId,
              agencyUserId: agencyUser._id ? agencyUser._id : "",
              permissions: selectedKeys,
            })
          }
        >
          Edit
        </Button>
      </div>
    </div>
  );
}
